export const MIN_PASSWORD_LENGTH = 8;

/**
 * Delay in milliseconds before showing loading UI states for unregistered contacts fetch.
 * This prevents flickering for fast API responses (< 2 seconds).
 */
export const LOADING_STATE_DISPLAY_DELAY_MS = 2000;